import { fil } from "date-fns/locale";
import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class CdrService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getCurrentCdrsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrServicesURLs.getAccountCdrs,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCdrsFromToStartDate = async (session_id, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrServicesURLs.getCdrsFromToStartDate +
          `from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
    getCdrsFromToStartDatePeagable = async (session_id, from, to, pageNum=0, pageSize=10, filters) => {
    try {
      if(pageNum != 0){
        pageNum--;
      }
      const queryParams = new URLSearchParams({
        page: pageNum,
        size: pageSize,
        ...filters
      })
      return await this.HttpService.getJson(
        this.constants.cdrServicesURLs.getCdrsFromToStartDate +
          `from/${from}` +
          `/to/${to}` +
          `/paginated`+
          `?${queryParams.toString()}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCdrsFromToStartDateByPage = async (session_id, from, to,page) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrServicesURLs.getCdrsFromToStartDate +
          `from/${from}` +
          `/to/${to}`+
          `/page/${page}` ,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllCdrsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrServicesURLs.getAllCdrs,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getSwitchedCRDIdService = async (session_id, cdrId, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrSwitchedServicesURLs.getSwitchesForCDR +
          `cdrId/${cdrId}` +
          `/from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllSwitchedCRDDateService = async (session_id, from, to) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cdrSwitchedServicesURLs.getSwitchesForCDR +
          `from/${from}` +
          `/to/${to}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getSelectedSwitchedCRDDateService = async (session_id, ids) => {
    try {
      return await this.HttpService.postJson(
        this.constants.cdrSwitchedServicesURLs.getSelectedSwitchesForCDRs,
        ids,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadCdrFiles = async (session_id, data) => {
    try {
      let filesList = await this.HttpService.downloadFiles(
        this.constants.fileServicesURLs.downloadCdrFiles,
        {
          cdrIds: data,
        },
        session_id
      );
      let blob = await fetch(filesList).then((r) => r.blob());
      return blob;
    } catch (e) {
      throw e;
    }
  };
  downloadCdrVoicemailFiles = async (session_id, data) => {
    try {
      let filesList = await this.HttpService.downloadFiles(
        this.constants.fileServicesURLs.downloadVoiceMailFiles,
        {
          voiceMailIds: data,
        },
        session_id
      );

      let blob = await fetch(filesList).then((r) => r.blob());
      return blob;
      // var a = window.document.createElement("a");

      // a.href = filesList;
      // a.download = "CDR_" + filename;

      // document.body.appendChild(a);
      // a.click();

      // document.body.removeChild(a);
    } catch (e) {
      throw e;
    }
  };


  searchBySpecificValuesInCdr = async (session_id, a,b,c,page,from,to) => {
    try {
      console.log("========== a "+a)
      console.log("========== b "+b)
      console.log("========== c "+c)

      return await this.HttpService.postJson(
        this.constants.cdrServicesURLs.getCdrsFromToStartDate+"search",
        {
          aNumber:a,
          bNumber:b,
          cNumber:c,
          page:page,
          from:from,
          to:to
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}


